import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme, { inline }) => ({
  root: {
    display: inline ? "inline-flex" : "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

export default useStyles;
//# sourceMappingURL=Center.styles.js.map
